export const BenefitType = {
  AT_PURCHASE: 100,
  SMART_WALLET: 200,
  COUPON: 300,
  GIFT: 400,
  SALES: 700,
  PAID_COUPON: 800,
  ISRACARD: 900,
  TRADE_PRODUCT: 1000,
  TRAVEL_INSURANCE: 1100,
  LEAD: 1200,
  PURCHASE_VOUCHER: 1300,
};

export const PricingType = {
  FIXED: 'fixed',
  RANGE: 'range',
};

export const UpsalePopupStatus = {
  SUCCESSFUL_PURCHASE: 'successful purchase',
  USED_THE_ELIGIBILITY: 'used the eligibility',
  NO_ELIGBILITY_REQUIREMENTS: 'no eligibility requirements',
  NO_INVENTORY: 'no inventory',
};

export const RECOMMENDATIONS_PROMOTION_GROUP = {
  DEFAULT_POPULAR: 1,
  RECOMMENDATIONS: 2,
  DEFAULT_RECOMMENDATIONS: 3,
};

export const RECOMMENDATIONS_PROMOTION_GROUP_NAME = {
  DEFAULT_POPULAR: 'default_popular',
  RECOMMENDATIONS: 'recommendations',
  DEFAULT_RECOMMENDATIONS: 'default_recommendations',
};
export const SendPlatform = {
  WHATSAPP: 'whatsapp',
  EMAIL: 'email',
  SMS: 'sms',
  COPY_LINK: 'copy_link',
  SHARE: 'share', 
};

export const ShareAnalyticsMethod = {
  WHATSAPP: 'Whatsapp',
  EMAIL: 'Email',
  SMS: 'SMS',
  COPY_LINK: 'Copy Link',
  SHARE: 'Share',
};

export const BannerLinkType = {
  DEEPLINK: 'deeplink',
  EXTERNAL: 'external',
};

export const SHARE_CONTENT_SOURCE = {
  JOIN_PAGE: 'join_page',
  BENEFIT_PAGE: 'benefit_page',
}